import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import AiProviderPanel from './AiProviderPanel';
import ApiUsageChart from '../../components/charts/ApiUsageChart';
import SettingsToolbar from '../../components/settings/SettingsToolbar';
import language from '../../variables/language';
import '../../css/ai-config.css';
import '../../css/vocabulary-config.css';

export default function AiConfig() {
  const t = language[language.lang].aiConfigPage;

  return (
    <Layout>
      <SettingsToolbar />
      <PageHeader name={t.title} />
      <main className="main-block">
        <div className="main-content txt-c">
          <AiProviderPanel />

          <h3 className="ai-config-usage-title">{t.providerGemini}</h3>
          <ApiUsageChart provider="GEMINI" />

          <h3 className="ai-config-usage-title">{t.providerOpenai}</h3>
          <ApiUsageChart provider="OPENAI" />

          <h3 className="ai-config-usage-title">{t.providerGroq}</h3>
          <ApiUsageChart provider="GROQ" />
        </div>
      </main>
    </Layout>
  );
}
